import { Link, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { Colors } from '../../../../../design/color/Colors';
import { ITheoryComponent } from '../ITheoryComponent';

export interface IHeading {
  text: string;
}
export const Heading3 = observer(({ data }: ITheoryComponent<IHeading>) => {
  return (
    <Typography variant="h6" sx={{ marginBottom: '32px', color: Colors.textPrimary }}>
      <Link
        sx={{ textDecoration: 'none', pointerEvents: 'none', cursor: 'none', color: Colors.textPrimary }}
        href={`#${data.text}`}
        id={data.text}
      >
        {data.text}
      </Link>
    </Typography>
  );
});
